import React from "react";
import { useCMS } from "../context/CMSContext";

/**
 * Live Mover hosting logo - stacked server stripes (default SVG).
 * If CMS site.logoUrl is set, render that image instead.
 */
export default function Logo({ size = 36, dark = false, className = "" }) {
  const { cms } = useCMS();
  const logoUrl = cms?.site?.logoUrl;
  const brand = cms?.site?.brandName || "Live Mover";

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={brand}
        width={size}
        height={size}
        className={`object-contain ${className}`}
        style={{ height: size, width: "auto", maxWidth: size * 2 }}
      />
    );
  }

  const bg = dark ? "#FFFFFF" : "#11151C";
  const stripe = "#FF6B3D";
  const stripeMuted = dark ? "#11151C" : "#FFFFFF";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={brand}
    >
      <rect width="40" height="40" rx="10" fill={bg} />
      <rect x="8" y="10" width="24" height="6" rx="2" fill={stripeMuted} opacity="0.18" />
      <circle cx="12" cy="13" r="1.1" fill={stripe} />
      <rect x="15.5" y="12.4" width="12" height="1.2" rx="0.6" fill={stripeMuted} opacity="0.55" />
      <rect x="8" y="17" width="24" height="6" rx="2" fill={stripe} />
      <circle cx="12" cy="20" r="1.1" fill={bg} />
      <rect x="15.5" y="19.4" width="12" height="1.2" rx="0.6" fill={bg} opacity="0.7" />
      <rect x="8" y="24" width="24" height="6" rx="2" fill={stripeMuted} opacity="0.18" />
      <circle cx="12" cy="27" r="1.1" fill={stripe} />
      <rect x="15.5" y="26.4" width="12" height="1.2" rx="0.6" fill={stripeMuted} opacity="0.55" />
    </svg>
  );
}
